module.exports = __webpack_public_path__ + "img/093-cloud-5.88110976.svg";